import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "flex items-center gap-2.5" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
    key: 1,
    class: "ri-building-line text-xl text-(--text-text-body-subtle)"
};
const _hoisted_4 = { class: "flex flex-col min-w-0" };
const _hoisted_5 = { class: "font-(family-name:--family-heading) text-(length:--size-xl) font-semibold leading-(--line-height-xl) tracking-(--letter-spacing-letter-spacing) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_6 = {
    key: 0,
    class: "flex justify-center items-center py-12"
};
const _hoisted_7 = {
    key: 1,
    class: "flex flex-col gap-4 overflow-x-hidden"
};
const _hoisted_8 = { class: "flex flex-col gap-1" };
const _hoisted_9 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_10 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_11 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_12 = { class: "flex flex-col gap-1" };
const _hoisted_13 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_14 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) min-w-0" };
const _hoisted_15 = { class: "flex flex-col gap-1" };
const _hoisted_16 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_17 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_18 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_19 = { class: "flex flex-col gap-1" };
const _hoisted_20 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_21 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_22 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_23 = { class: "flex flex-col gap-1" };
const _hoisted_24 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_25 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_26 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_27 = { class: "flex flex-col gap-1" };
const _hoisted_28 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_29 = { class: "flex flex-wrap items-center gap-1.5 px-2.5 py-2 min-h-9 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-black-default)" };
const _hoisted_30 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Badge, Button, Drawer, Tooltip } from "@eudonet/opal";
import { INDUSTRY_SECTOR_FALLBACK, normalizeIndustrySector } from "../../domain/industry-sector";
import { useTruncationDetector } from "@/shared/composables/useTruncationDetector";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationPreviewDrawer',
    props: {
        modelValue: { type: Boolean },
        org: {},
        loading: { type: Boolean }
    },
    emits: ["update:modelValue", "go-to-organisation"],
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const industrySectorLabel = computed(() => {
            const normalized = normalizeIndustrySector(props.org?.industrySector);
            return normalized === INDUSTRY_SECTOR_FALLBACK
                ? t("organisation.detail.options.industrySector.other")
                : normalized;
        });
        const addressText = computed(() => props.org?.address || props.org?.city || "—");
        const locationText = computed(() => [props.org?.city, props.org?.country].filter((part) => !!part && part.trim() !== "").join(", "));
        const addressSpanRef = ref(null);
        const { isTruncated: isAddressTruncated } = useTruncationDetector(addressSpanRef, addressText);
        const locationSpanRef = ref(null);
        const { isTruncated: isLocationTruncated } = useTruncationDetector(locationSpanRef, locationText);
        const EstablishmentNatureThemeMap = {
            Headquarters: "indigo",
            Subsidiary: "purple",
            Branch: "green",
            RepresentativeOffice: "red",
        };
        function getTheme(tag) {
            return EstablishmentNatureThemeMap[tag] ?? "neutral";
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Drawer), {
                "model-value": __props.modelValue,
                position: "right",
                size: "md",
                "show-close-button": true,
                "close-on-escape": true,
                dismissable: true,
                "backdrop-class": "!z-[55]",
                "panel-class": "!z-[60]",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update:modelValue', $event)))
            }, _createSlots({
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "primary",
                        "full-width": "",
                        label: _ctx.$t('organisation.create.dedup.viewRecord'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (__props.org && _ctx.$emit('go-to-organisation', __props.org.id)))
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1 /* CACHED */)
                            ]))]))
                        : (__props.org)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("organisation.create.fields.legalName")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_10, [
                                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-building-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(__props.org.legalName), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("organisation.create.fields.address")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-map-pin-2-line text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) shrink-0" }, null, -1 /* CACHED */)),
                                        _createVNode(_unref(Tooltip), {
                                            text: addressText.value,
                                            disabled: !_unref(isAddressTruncated),
                                            class: "block min-w-0 flex-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                    ref_key: "addressSpanRef",
                                                    ref: addressSpanRef,
                                                    class: "block w-full text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate"
                                                }, _toDisplayString(addressText.value), 513 /* TEXT, NEED_PATCH */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["text", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("organisation.create.fields.siret")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(__props.org.primaryRegistrationNumber || "—"), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.organisationType")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("span", _hoisted_22, _toDisplayString(__props.org.organisationType
                                            ? _ctx.$t(`organisation.detail.options.organisationType.${__props.org.organisationType}`)
                                            : "—"), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.industrySector")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(industrySectorLabel.value), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.establishmentNature")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_29, [
                                        (__props.org.establishmentNature)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.org.establishmentNature.split(','), (tag) => {
                                                return (_openBlock(), _createBlock(_unref(Badge), {
                                                    key: tag.trim(),
                                                    label: _ctx.$t(`organisation.detail.options.establishmentNature.${tag.trim()}`),
                                                    theme: getTheme(tag.trim()),
                                                    size: "sm",
                                                    "show-close-icon": false
                                                }, null, 8 /* PROPS */, ["label", "theme"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (__props.org)
                    ? {
                        name: "header",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["size-12 shrink-0 flex items-center justify-center overflow-hidden rounded-full",
                                        __props.org.logoUrl
                                            ? ''
                                            : 'border border-(--border-border-base-soft) bg-(--background-background-selected)'
                                    ])
                                }, [
                                    (__props.org.logoUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: __props.org.logoUrl,
                                            alt: __props.org.legalName,
                                            class: "size-full object-cover"
                                        }, null, 8 /* PROPS */, _hoisted_2))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_3))
                                ], 2 /* CLASS */),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.org.legalName), 1 /* TEXT */),
                                    (locationText.value)
                                        ? (_openBlock(), _createBlock(_unref(Tooltip), {
                                            key: 0,
                                            text: locationText.value,
                                            disabled: !_unref(isLocationTruncated),
                                            class: "block min-w-0"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                    ref_key: "locationSpanRef",
                                                    ref: locationSpanRef,
                                                    class: "block w-full font-(family-name:--family-heading) text-(length:--size-l) font-normal leading-(--line-height-xxl) tracking-(--letter-spacing-letter-spacing) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate"
                                                }, _toDisplayString(locationText.value), 513 /* TEXT, NEED_PATCH */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["text", "disabled"]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value"]));
        };
    }
});
